module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOCIgaGVpZ2h0PSIyOCIgdmlld0JveD0iMCAwIDI4IDI4Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggc3Ryb2tlPSIjZTBlMGUwIiBkPSJNLjUgMjcuNDk5bDI3LS4wNjFWNy42TDIxLjYzLjVILjV2MjYuOTk5eiIvPgogICAgICAgIDxwYXRoIGZpbGw9IiNlMGUwZTAiIGQ9Ik0yMi4xNjcuOTRsNC45ODggNi4xMjdoLTQuOTg4ek0zIDkuMDIxaDE2VjYuOTY4SDN6TTMgMTIuOTloMjB2LTIuMDUzSDN6TTMgMTcuMDUzaDlWMTVIM3pNMyAyMS4wNTNoMjJWMTlIM3pNMyAyNS4wNTNoMTZWMjNIM3pNMyA1LjA1M2g3VjNIM3oiLz4KICAgIDwvZz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/file-type-doc-icon-disabled.svg
// module id = 2732
// module chunks = 0